var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alert_width" },
    [
      _c("div", { staticStyle: { padding: "0 10px" } }, [
        _vm._v(_vm._s(_vm.$t("etc.notice.title"))),
      ]),
      _c("b-dropdown-divider"),
      _c(
        "div",
        { staticClass: "alert-body" },
        [
          _vm.loading && _vm.alert_list.length === 0
            ? _c("div", { staticStyle: { height: "50px" } }, [_vm._m(0)])
            : _vm.alert_list.length === 0
            ? _c(
                "div",
                {
                  staticClass: "text-muted",
                  staticStyle: { padding: "0 10px" },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("etc.notice.err")) + "\n    "
                  ),
                ]
              )
            : _vm._l(_vm.alert_list, function (alert, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("div", { staticStyle: { padding: "0 10px" } }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "text-black bold font-s16 mt-1" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(alert.title) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticStyle: { padding: "0 !important" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteNoti(alert.id)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "close",
                                attrs: {
                                  src: `${_vm.$s3}/img/common/mypage/delete.svg?${_vm.$ver}`,
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-end justify-content-between",
                          staticStyle: { gap: "1rem" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "font-s14 mt-1",
                              staticStyle: { color: "#666666" },
                            },
                            [
                              _c("div", [
                                _vm._v(_vm._s(alert.content.split("|")[0])),
                              ]),
                              _c("div", [
                                _vm._v(_vm._s(alert.content.split("|")[1])),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "text-muted font-s12 mt-1" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$tfDateShort(
                                      _vm.$tl(alert.createdAt, _vm.lang)
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    index < _vm.alert_list.length - 1
                      ? _c("b-dropdown-divider")
                      : _vm._e(),
                  ],
                  1
                )
              }),
          _c(
            "button",
            { staticClass: "go-to-alert", on: { click: _vm.goToAlert } },
            [_vm._v(_vm._s(_vm.$t("etc.notice.seeall")))]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          transform: "translate(-50%, 0)",
          position: "absolute",
          left: "50%",
          height: "50px",
        },
      },
      [_c("div", { attrs: { id: "loading" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }